import api from './api';
import { handleError } from '../utils/errorHandler';

export const downloadRelatorioPLFundos = async (fundoId: number): Promise<void> => {
  try {
    const response = await api.get(`/ativos/relatorio-pl-fundos/?fundo_id=${fundoId}`, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `pl_fundo_${fundoId}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    handleError(error, 'ao gerar relatório de patrimônio líquido');
    throw error;
  }
};
